import React, { useState } from 'react';
import {
	MDBMask as Mask,
	MDBRow as Row,
	MDBCol as Col,
	MDBBtn as Btn,
	MDBView as View,
	MDBContainer as Container,
	MDBCard as Card,
	MDBCardBody as CardBody,
	MDBInput as Input,
	MDBCardImage as CardImage,
	MDBNotification as Notification
} from 'mdbreact';

import { saveEmail } from '../../api/emailApi';

const Intro = () => {
	const [btnDisable, setBtnDisable] = useState(false);
	const [success, setSuccess] = useState(false);
	const [error, setError] = useState(false);
	const [warning, setWarning] = useState(false);
	const [email, setEmail] = useState('');
	const handleSubmit = () => {
		if (email.length > 0) {
			if (validateEmail(email)) {
				setBtnDisable(true);
				saveEmail(email)
					.then((res) => {
						console.log(res);
						if (res.result) setSuccess(true);
						else setError(true);
						setEmail('');
						setBtnDisable(false);

						setTimeout(() => {
							setError(false);
							setSuccess(false);
						}, 3000);
					})
					.catch((err) => {
						setError(true);
						setTimeout(() => {
							setError(false);
						}, 3000);
					});
			} else {
				setWarning(true);
				setTimeout(() => {
					setWarning(false);
				}, 3000);
			}
		}
	};
	const handleEmail = (e) => {
		setEmail(e.target.value);
	};

	const validateEmail = (email) => {
		const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(String(email).toLowerCase());
	};

	return (
		<main id='home'>
			<View
				src={`market.jpg`}
				data-jarallax='{"speed": 0.2}'
				className='jarallax'>
				<Mask overlay='black-light'>
					<Mask
						className='d-flex justify-content-center align-items-center'
						overlay='black-strong'>
						<Container>
							<Row>
								<Col
									md='10'
									lg='8'
									xl='6'
									className='mb-4 white-text text-center mx-auto'>
									<h1
										data-aos='fade-up'
										data-aos-delay='50'
										className='display-3 d-none d-md-block h1-reponsive white-text text-uppercase font-weight-bold mb-0 pt-md-5 pt-5 '>
										MEGA Q MART
									</h1>
									<h1
										data-aos='fade-up'
										data-aos-delay='50'
										className='d-block d-md-none h1-reponsive white-text text-uppercase font-weight-bold mb-0 pt-md-5 pt-5 '>
										MEGA Q MART
									</h1>
									<h5
										data-aos='fade-up'
										data-aos-delay='200'
										style={{ backgroundColor: '#059E03' }}
										className='text-uppercase white-text py-1 px-3 font-weight-bold d-none d-md-block'>
										<strong>will go online soon!</strong>
									</h5>
									<h5
										data-aos='fade-up'
										data-aos-delay='200'
										style={{ backgroundColor: '#059E03' }}
										className='text-uppercase white-text py-1 px-3 font-weight-bold d-inline-block d-md-none'>
										<strong>will go online soon!</strong>
									</h5>
									<hr
										className='hr-light my-4'
										data-aos='fade-up'
										data-aos-delay='350'
									/>
									<h5 data-aos='fade-up' data-aos-delay='500'>
										Ang dating Nepa Q Mart, Mega Q Mart na ngayon!
									</h5>
								</Col>
							</Row>
						</Container>
					</Mask>
				</Mask>
			</View>
			<Container>
				<Row
					className='my-md-5'
					style={{ position: 'relative', top: '-150px', zIndex: '2' }}>
					<Col md='7' className='mx-auto'>
						<Card narrow className=' py-1 px-3' data-jarallax-element='-140'>
							<CardImage
								style={{ backgroundColor: '#ff6701' }}
								className='view view-cascade rounded'
								cascade
								tag='div'>
								<p className='font-small font-weight-lighter text-center mt-3 white-text px-3'>
									Subscribe and you'll receive a notification about our release
									date and promos
								</p>
							</CardImage>
							<CardBody cascade>
								<Row>
									<Col xl={8}>
										<Input
											style={{ color: '#4d4d4d' }}
											label='Your email'
											value={email}
											onChange={handleEmail}
										/>
									</Col>
									<Col xl={4}>
										<Btn
											color='#ff6701'
											className='btn-block my-4'
											onClick={handleSubmit}
											disabled={btnDisable}>
											Subscribe
										</Btn>
									</Col>
								</Row>
							</CardBody>
						</Card>
					</Col>
				</Row>
			</Container>
			<Container
				style={{
					width: 'auto',
					position: 'fixed',
					top: '90px',
					right: '8px',
					zIndex: 9999
				}}>
				<Notification
					className={success ? 'd-block' : 'd-none'}
					closeClassName='d-none'
					show
					fade
					iconClassName='text-success'
					title='Success'
					message='Great! you will now receive monthly notification about our release
					date and promos'
					// text='just now'
				/>
				<Notification
					className={error ? 'd-block' : 'd-none'}
					closeClassName='d-none'
					show
					fade
					iconClassName='text-danger'
					title='Error'
					message='There must be something wrong with the server, please try again later.'
					// text='2 seconds ago'
				/>

				<Notification
					className={warning ? 'd-block' : 'd-none'}
					closeClassName='d-none'
					show
					fade
					iconClassName='text-warning'
					title='Warning'
					message='Email is not valid.'
					// text='2 seconds ago'
				/>
			</Container>
		</main>
	);
};

export default Intro;
